import { pwaSave } from "@/lobby_common/api/user_gen.js";
import Bus from "@/lobby_common/utils/bus.js";
import Store from "@/lobby_common/store/index";

let VAPIDPublicKey = "";
// 注册 service worker 并缓存 registration
let registration = null;
export function registerServiceWorker() {
  if (!navigator.serviceWorker) {
    return Promise.reject("系统不支持 service worker");
  }

  if (registration) {
    return Promise.resolve(registration);
  }
  return navigator.serviceWorker
    .register("/service-worker.js?v=" + window._custom_env_.version)
    .then(function (reg) {
      registration = reg;
    })
    .catch((error) => {
      console.log("Service Worker 注册失败:", error);
    });
}

export function sendMessage(data) {
  if (registration && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage(data);
  } else {
    registerServiceWorker().then(() => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage(data);
      }
    });
  }
}

// 申请桌面通知权限
export function requestNotificationPermission() {
  // 系统不支持桌面通知
  if (!window.Notification) {
    console.log("系统不支持桌面通知:");
    return Promise.reject("系统不支持桌面通知");
  }
  return Notification.requestPermission()
    .then(function (permission) {
      if (permission === "granted") {
        console.log("用户已同意桌面通知权限:");
        // 记录用户同意桌面通知权限状态
        localStorage.setItem("notificationPermission", "granted");
        return Promise.resolve();
      }
      localStorage.setItem("notificationPermission", "denied");
      console.log("用户已禁止桌面通知权限:");
      return Promise.reject('用户已禁止桌面通知权限')
    })
    .catch((error) => {
      console.log("请求通知权限时发生错误:", error);
      return Promise.reject(error);
    });
}

// 订阅推送并将订阅结果发送给后端
function subscribeAndDistribute(registration) {
  if (!window.PushManager) {
    return Promise.reject("系统不支持消息推送");
  }
  // 检查是否已经订阅过
  return registration.pushManager
    .getSubscription()
    .then(function (subscription) {
      // 如果已经订阅过，就不重新订阅了
      if (subscription) {
        // 订阅推送成功之后，将订阅信息传给后端服务器
        distributePushResource(subscription);
        return;
      }
      // 如果尚未订阅则发起推送订阅
      return registration.pushManager
        .subscribe({
          userVisibleOnly: true,
          applicationServerKey: base64ToUint8Array(VAPIDPublicKey),
        })
        .then(function (subscription) {
          // 订阅推送成功之后，将订阅信息传给后端服务器
          distributePushResource(subscription);
        })
        .catch((error) => {
          console.log("失败1:", error);
        });
    })
    .catch((error) => {
      console.log("失败2:", error);
    });
}

function distributePushResource(subscription) {
  return pwaSave({
    endpoint: subscription.endpoint,
    p256dh: uint8ArrayToBase64(subscription.getKey("p256dh")),
    auth: uint8ArrayToBase64(subscription.getKey("auth")),
  });
}

function uint8ArrayToBase64(arr) {
  return btoa(String.fromCharCode.apply(null, new Uint8Array(arr)));
}

function base64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function register(PublicKey) {
  VAPIDPublicKey = PublicKey || VAPIDPublicKey;
  console.log("ws publicKey=>", VAPIDPublicKey);
  init();
  Bus.$off("registerWorker");
  Bus.$on("registerWorker", init);
}

function init() {
  // 注册 service worker
  if (!Store.getters.taken) return;

  console.log("ws register");
  registerServiceWorker() // 申请桌面通知权限
    .then(function () {
      // console.log('111111111111111111111111111111111')
      requestNotificationPermission();
    })
    // 订阅推送
    .then(function () {
      // console.log('22222222222222222222222222222222222222222')
      subscribeAndDistribute(registration);
    })
    .catch(function (err) {
      console.log("ws error", err);
    });
}
